import React from 'react'

const Section = ({name,description,children}) => {
  return (
    <div className='relative flex flex-col w-full h-fit space-y-12'>
      <div className='flex flex-col w-full items-center space-y-6'>
        <p className='text-heading text-center text-[34px] font-nunitoSansBold'>
          {name?name:''}
        </p>
        <p className='w-full sm:w-[450px] md:w-[610px] px-4 lg:w-[730px] font-nunitoSansRegular text-[16px]/[28px] text-gray text-center'>
          {description?description:''}
        </p>
      </div>
      <div className='w-full'>
        {children}
      </div>
    </div>
  )
}

export default Section